module.exports = __webpack_public_path__ + "static/media/final-mocks.61bd56f6.png";